import { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { Loader } from '@elfsight/widget-ui';
import justifiedLayout from 'justified-layout';
import { meta } from '../../../../meta';
import {
  getColumns,
  getLayoutObjFromName,
  getRatio,
  getSecondColor
} from '../../../helpers';

export const Boxes = ({
  ratios = [],
  width,
  children,
  mobile,
  tablet,
  gutter,
  settings
}) => {
  const [sizes, setSizes] = useState({});
  const {
    layout,
    gridColumns,
    gridGutter,
    gridColumnsTablet,
    gridGutterTablet,
    gridColumnsMobile,
    gridGutterMobile,
    gridImageRatio,
    gridImageResize,
    gridLoadMoreButton,
    gridRowsPerPage,
    verticalMasonryColumns,
    verticalMasonryGutter,
    verticalMasonryColumnsTablet,
    verticalMasonryGutterTablet,
    verticalMasonryColumnsMobile,
    verticalMasonryGutterMobile,
    verticalMasonryLoadMoreButton,
    verticalMasonryImagesPerPage,
    horizontalMasonryThumbnailSize,
    horizontalMasonryGutter,
    horizontalMasonryThumbnailSizeTablet,
    horizontalMasonryGutterTablet,
    horizontalMasonryThumbnailSizeMobile,
    horizontalMasonryGutterMobile,
    horizontalMasonryLoadMoreButton,
    horizontalMasonryImagesPerPage,
    backgroundType,
    backgroundColor,
    backgroundImageOverlayColor
  } = settings;
  const { type, view, name, direction } = getLayoutObjFromName(layout);
  useLayoutEffect(() => {
    const columns = (() => {
      if (tablet) {
        return getColumns(settings).tablet;
      }

      if (mobile) {
        return getColumns(settings).mobile;
      }

      return getColumns(settings).default;
    })();

    if (view === 'masonry' && direction === 'horizontal') {
      const thumbnailSize = (() => {
        if (tablet) {
          return horizontalMasonryThumbnailSizeTablet;
        }

        if (mobile) {
          return horizontalMasonryThumbnailSizeMobile;
        }

        return horizontalMasonryThumbnailSize;
      })();

      setSizes(
        justifiedLayout(ratios || [], {
          containerWidth: width,
          boxSpacing: {
            horizontal: gutter,
            vertical: gutter
          },
          containerPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          targetRowHeight: thumbnailSize,
          targetRowHeightTolerance: 0.25
        })
      );
    }

    if (view === 'masonry' && direction === 'vertical') {
      setSizes({
        boxes: (ratios || []).map((item) => {
          return {
            aspectRatio: item,
            width: (width - gutter * (columns - 1)) / columns,
            height: 'auto'
          };
        })
      });
    }

    if (view === 'grid') {
      setSizes({
        boxes: (ratios || []).map((item) => {
          return {
            aspectRatio: item,
            width: (width - (gutter * (columns - 1) + 1)) / columns,
            height: (width / columns) * getRatio(settings)
          };
        })
      });
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ratios,
    gutter,
    width,
    children,
    mobile,
    tablet,
    type,
    view,
    direction,
    name,
    gridColumns,
    gridGutter,
    gridColumnsTablet,
    gridGutterTablet,
    gridColumnsMobile,
    gridGutterMobile,
    gridImageRatio,
    gridImageResize,
    gridLoadMoreButton,
    gridRowsPerPage,
    verticalMasonryColumns,
    verticalMasonryGutter,
    verticalMasonryColumnsTablet,
    verticalMasonryGutterTablet,
    verticalMasonryColumnsMobile,
    verticalMasonryGutterMobile,
    verticalMasonryLoadMoreButton,
    verticalMasonryImagesPerPage,
    horizontalMasonryThumbnailSize,
    horizontalMasonryGutter,
    horizontalMasonryThumbnailSizeTablet,
    horizontalMasonryGutterTablet,
    horizontalMasonryThumbnailSizeMobile,
    horizontalMasonryGutterMobile,
    horizontalMasonryLoadMoreButton,
    horizontalMasonryImagesPerPage
  ]);

  const { boxes } = sizes;

  if (boxes?.length) {
    return children({ sizes });
  }

  const secondColor = getSecondColor({
    backgroundType,
    backgroundColor,
    backgroundImageOverlayColor
  });

  return (
    <Container>
      <Loader size={40} color={secondColor} />
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${meta.stylePrefix}-boxes-loader`
})`
  width: 100%;
  display: flex;
  padding: 100px;
  justify-content: center;
`;
